import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { MarketSelect } from "Settings/Components/MarketSelect";
import { SettingsPaths } from "Settings/Routes/Routing";
import { PageContainer } from "Shared/Components/Container";
import { Navigate } from "react-router";

const orderSetupResource = Resources.base.orderSetup.shared;

export const MarketSelectPage = () => {
	const { t } = useResource();
	const { market: selectedMarket } = useMarket();

	return (
		<PageContainer
			title={t(orderSetupResource.indexPageTitle)}
			description={t(orderSetupResource.indexPageDescription)}
		>
			{selectedMarket ? (
				<Navigate
					to={SettingsPaths.VerticalSetupVerticalSelect.path(selectedMarket.id)}
				/>
			) : (
				<MarketSelect />
			)}
		</PageContainer>
	);
};
